<template>
    <div class="returnGoodSale">
        <el-tabs type="border-card" v-model='curTabindex' stretch>
            <el-tab-pane label="退货" name='first'>
                <div class="returnGoodDetail">
                    <el-form ref="form" :model="form" :rules="rules" label-width="160px" @submit.native.prevent>
                        <el-form-item label="销售订单" prop="orderId">
                            <el-input v-model="form.orderId" placeholder="请输入销售订单" style="width:190px;margin-right:20px" @keyup.enter.native='search' ref="defaultinput" autofocus="autofocus"></el-input>
                            <el-button class="searchBtn" @click="search()"></el-button>
                        </el-form-item>
                        <template v-if="serviceProList">
                            <el-form-item label-width="120px">
                                <el-col :span='10'>
                                    <span>会员</span>&nbsp;&nbsp;{{infoData.memberName | filterRow}}
                                </el-col>
                                <el-col :span='14'>
                                    <span>手机号</span>&nbsp;&nbsp;{{infoData.memberTelephone}}
                                </el-col>
                            </el-form-item>
                            <el-form-item label="支付方式">
                                <p v-for="(i,index) in payMentType(infoData)" :key="'returnMoney-' +index">{{i}}</p>
                            </el-form-item>
                            <el-form-item label="商品" prop="servicePro" style="margin:10px 0">
                                <template v-if="!serviceProList">
                                    <span>--</span>
                                </template>
                                <template v-else-if="serviceProList.length > 0">
                                    <el-select v-model="form.servicePro" value-key="id" placeholder="请选择商品" style="width:190px" @change="chooseReturn">
                                        <el-option v-for="i in serviceProList" :key="i.id" :label="i.goodsName" :value="i"></el-option>
                                    </el-select>
                                </template>
                                <template v-else>
                                    <span class="red">抱歉！暂无剩余项目</span>
                                </template>
                            </el-form-item>
                            <el-form-item label="类型">
                                <span>{{form.servicePro.addType | filterAddType | filterRow}}</span>
                                <div class="list" v-if="form.servicePro.addType && form.servicePro.addType != 4">
                                    <template v-if='form.servicePro.addType == 3'>
                                        <el-form-item prop="serviceProListNo" style="margin-bottom:10px">
                                            <el-checkbox-group v-model="form.serviceProListNo" class="checkBoxcom">
                                                <div v-for="(i,index) in form.servicePro.orderGoodsDetailsList" :key="'serviceProListNo'+index">
                                                    <el-checkbox :label="i">
                                                        {{i.goodsName}}&nbsp;&nbsp;
                                                        <span>购买次数：{{i.courseStyle == 1?i.containFrequency:(i.courseStyle == 2 ? i.addDate+'个月':i.addDate+'个月 ' + i.containFrequency+'次') | filterRow}}</span>&nbsp;&nbsp;
                                                        <span>剩余次数：
                                                            <span v-if="i.courseStyle == 1">{{i.residueFrequency >= 0?i.residueFrequency:(i.residueFrequency | filterRow)}}</span>
                                                            <span v-if="i.courseStyle == 2">{{i.serviceEndDate | formatDateNoHouer | filterRow}}</span>
                                                            <span v-if="i.courseStyle == 3">{{(i.serviceEndDate+i.residueFrequency+'次') | filterRow}}</span>
                                                        </span>
                                                    </el-checkbox>
                                                </div>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </template>
                                    <div v-else v-for="(i,index) in form.servicePro.orderGoodsDetailsList" :key="'list'+index">
                                        <template v-if="form.servicePro.addType == 19 || form.servicePro.addType == 20">
                                            <!-- 零售 -->
                                            <!-- <span>购买数量：{{form.servicePro.saleNumber}}</span>&nbsp;&nbsp; -->
                                        </template>
                                        <template v-else>
                                            <span>{{form.servicePro.addType == 7? '时间限制':'购买次数'}}：{{i.courseStyle == 1?i.containFrequency:(i.courseStyle == 2 ? i.addDate+'个月':i.addDate+'个月 ' + i.containFrequency+'次') | filterRow}}</span>&nbsp;&nbsp;
                                            <span>{{form.servicePro.addType == 7? '购买时间':'剩余次数'}}：
                                                <span v-if="i.courseStyle == 1">{{i.residueFrequency >= 0?i.residueFrequency:(i.residueFrequency | filterRow)}}</span>
                                                <span v-if="i.courseStyle == 2">{{i.serviceEndDate | formatDateNoHouer | filterRow}}</span>
                                                <span v-if="i.courseStyle == 3">{{(i.serviceEndDate+i.residueFrequency+'次') | filterRow}}</span>
                                            </span>&nbsp;&nbsp;
                                        </template>
                                    </div>
                                    <div>
                                        <span>销售数量：{{form.servicePro.saleNumber}}</span>&nbsp;&nbsp;
                                        <span>销售总价：{{(Number(form.servicePro.salePrice)*form.servicePro.saleNumber).toFixed(2)}}</span>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item v-if="form.servicePro.addType == 4">
                                <span class="red">体验券服务暂不支持退款！</span>
                            </el-form-item>
                            <template v-else>
                                <el-form-item label="是否退库存" prop='returnStock' v-if="returnStockFlag">
                                    <el-radio-group v-model="form.returnStock">
                                      <el-radio :label="2" v-if="form.servicePro.addType == 7 || this.form.servicePro.addType == 6">无库存</el-radio>
                                      <div v-else>
                                        <el-radio :label="1">整套库存</el-radio>
                                        <el-radio :label="0">单次库存</el-radio>
                                      </div>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="应退金额" prop="returnAmoutMoney" style="margin:24px 0 0">
                                    <el-input v-model="form.returnAmoutMoney" placeholder="请输入应退金额" style="width:190px"></el-input>
                                </el-form-item>
                                <el-row class="returnBtnOptions">
                                    <el-button class="redBtn" @click='toPaswd(1,"form",form.returnAmoutMoney)'>退款</el-button>
                                </el-row>
                            </template>
                        </template>
                    </el-form>
                </div>
            </el-tab-pane>
            <el-tab-pane label="退款" name='second'>
                <div class="returnMoney">
                    <el-form ref="moneyform" :model="moneyform" :rules="rules" label-width="160px" @submit.native.prevent>
                        <el-form-item label="会员" prop="name">
                            <el-input v-model="moneyform.name" placeholder="请输入会员姓名/手机号" style="width:190px;margin-right:20px" @keyup.enter.native="searchTel" ref="defaultinput1"></el-input>
                            <el-button class="searchBtn" @click="searchTel"></el-button>
                        </el-form-item>
                        <template v-if="memInfo">
                            <el-form-item label="会员手机号">{{memInfo.phone?memInfo.phone:'--'}}</el-form-item>
                            <el-form-item label="充值余额"><span class="orangeFont">¥ {{fixmoney(memInfo,1)}}</span></el-form-item>
                            <el-form-item label="赠送余额"><span class="orangeFont">¥ {{fixmoney(memInfo,2)}}</span></el-form-item>
                            <el-form-item label="返现余额"><span class="orangeFont">¥ {{fixmoney(memInfo,3)}}</span></el-form-item>
                            <el-form-item label="会员余额合计"><span class="orangeFont">¥ {{total(memInfo)}}</span></el-form-item>
                            <el-form-item prop="leaveMsg">
                                <el-input type="textarea" v-model="moneyform.leaveMsg" autocomplete="off" placeholder="留言，20字以内" style="width:220px;height:90px;" resize="none"></el-input>
                            </el-form-item>
                            <el-row class="returnBtnOptions">
                                <el-button :class="total(memInfo) > 0 ? 'redBtn':'greyBtn'" :disabled="total(memInfo) == 0" @click='toPaswd(2,"moneyform",fixmoney(memInfo,1))'>下一步</el-button>
                            </el-row>
                        </template>
                    </el-form>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { formatDate } from '@/components/common/js/date.js';
import {saleOrderInfo, queryMemberOfflineForSearch, ServiceInfos} from '@/api'

export default {
    props:['dialogReturnVisible','moneyReturnform'],
    data() {
        // 价格
        const isvalidateMoney = (rule, value, callback) => {
        if (value != null && value != "") {
            if (/^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) == false) {
            callback(new Error("金额只能为正数或者两位小数"));
            } else if (value > 999999.99) {
            callback(new Error("金额最大999999.99"));
            } else {
            callback();
            }
        } else {
            callback();
        }
        };
        return {
            form:{
                orderId:'',
                servicePro:'',
                serviceProListNo:[],
                returnStock:0,
                returnAmoutMoney:'',
            },
            moneyform:{
                name:'',
                leaveMsg:''
            },
            infoData:'',
            serviceProList:'',
            memInfo:'',
            memInfoList:'',
            rules:{
                orderId:[
                    { required: true, message: "请输入销售订单", trigger: "blur" }
                ],
                servicePro:[
                    { required: true, message: '请至少选择一个商品', trigger: 'change' }
                ],
                returnStock:[
                    { required: true, message: '请选择是否退回库存', trigger: 'change' }
                ],
                leaveMsg:[
                    { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur"}
                ],
                name:[
                    { required: true, message: "请输入会员姓名/手机号", trigger: "blur" }
                ],
                serviceProListNo:[
                    { required: true, message: '请至少选择一个服务', trigger: 'change' }
                ],
                returnAmoutMoney:[
                    { required: true, message: "请输入应退金额", trigger: "blur" },
                    { validator: isvalidateMoney, trigger: "blur" }
                ]
            },
            curTabindex:'first',
            returnStockFlag:true,
        }
    },
    watch: {
        curTabindex(){
            this.serviceProList = ''
            this.memInfo = '';
            this.form = this.$options.data().form;
            this.moneyform = this.$options.data().moneyform;
            this.$nextTick(()=>{
                this.$refs.defaultinput.focus();
                this.$refs.defaultinput1.focus();
                this.$refs.form.clearValidate();
                this.$refs.moneyform.clearValidate();
            })
        },
        moneyReturnform(val){
            if(val){
                if(/^1[3456789]\d{9}$/.test(this.moneyform.name)){
                    return;
                }
                this.$set(this.moneyform,'name',this.moneyReturnform.name);
                this.memInfo = Object.assign({},this.moneyReturnform);
            }
        },
        dialogReturnVisible(val){
            if(val){
                this.serviceProList = ''
                this.memInfo = '';
                this.form = this.$options.data().form;
                this.moneyform = this.$options.data().moneyform;
                this.curTabindex = 'first';
                this.$nextTick(()=>{
                    this.$refs.form.clearValidate();
                    this.$refs.defaultinput.focus();
                })
            }
        }
    },
    computed: {
        payMentType(){
            return (val)=>{
                let data = [];
                if(val){
                    if(Number(val.cash) >0){
                        data.push('现金 ￥'+val.cash.toFixed(2))
                    }
                    if(Number(val.bankMoney)>0){
                        data.push('银行卡 ￥'+val.bankMoney.toFixed(2))
                    }
                    if(Number(val.alipayMoney)>0){
                        data.push('支付宝 ￥'+val.alipayMoney.toFixed(2))
                    }
                    if(Number(val.wechatpayMoney)>0){
                        data.push('微信 ￥'+val.wechatpayMoney.toFixed(2))
                    }
                    if(Number(val.rechargeAccountMoney)>0){
                        data.push('充值账户 ￥'+val.rechargeAccountMoney.toFixed(2))
                    }
                    if(Number(val.giftAccountMoney)>0){
                        data.push('赠送账户 ￥'+val.giftAccountMoney.toFixed(2))
                    }
                    if(Number(val.returnMoney)>0){
                        data.push('返现账户 ￥'+val.returnMoney.toFixed(2))
                    }
                }
                return data.length > 0?data:'无';
            }
        },
        fixmoney(){
            return (val,type)=>{
                let total = 0;
                if(val.accountOffList && val.accountOffList[0]){
                    if(type == 1){
                        total = Number(val.accountOffList[0].rechargeOff);
                    }else if(type == 2){
                        total = Number(val.accountOffList[0].giftOff);
                    }else if(type == 3){
                        total = Number(val.accountOffList[0].backOff);
                    }
                }
                return total.toFixed(2)
            }
        },
        total(){
            return (val)=>{
                let total = 0;
                if(val.accountOffList && val.accountOffList[0]){
                    total = Number(val.accountOffList[0].rechargeOff) + Number(val.accountOffList[0].giftOff) + Number(val.accountOffList[0].backOff)
                }
                return total.toFixed(2);
            }
        },
        computedOrderList(){
            return (id,val)=>{
                // 现在是单商品状态，为兼容以后多商品需多数组集合
                let data = {},lastData=[];
                if(val){
                    let orderGoods = [];
                    data.id = id;
                    data.orderGoodsDetailsList = orderGoods;
                    for(let i of val){
                        orderGoods.push({
                            id:i.id
                        })
                    }
                }
                lastData.push(data);
                return lastData;
            }
        },
    },
    methods: {
        chooseReturn(){
            // if(this.form.servicePro.goodsType == 1){
                ServiceInfos({
                    serviceId: this.form.servicePro.goodsId
                }).then(resGoods=>{
                    if(resGoods.data.needProd == 1){
                        this.returnStockFlag = true;
                        if(this.form.servicePro.addType == 7 || this.form.servicePro.addType == 6){
                          this.form.returnStock  = 2
                        }else{
                          this.form.returnStock  = 0
                        }
                    }else{
                        this.returnStockFlag = false;
                    }
                })
            // }else{
            //     this.returnStockFlag = true;
            // }
        },
        search(){
            if(!this.form.orderId){
                this.$confirm( '请先输入销售订单号再查询！', "提示", {
                    showCancelButton: false,
                    type: "warning"
                })
                return;
            }
            saleOrderInfo({
                orderId: this.form.orderId
            }).then(lastRes => {
                if(lastRes.data){
                    this.form.servicePro =  '';
                    this.form.serviceProListNo = [];
                    this.infoData = lastRes.data;
                    this.serviceProList = lastRes.data.orderGoodsList;
                    this.$nextTick(()=>{
                        this.$refs.form.clearValidate();
                    })
                }else{
                    this.infoData = '';
                    this.serviceProList = '';
                    this.$confirm( '查不到该销售订单，请检查销售订单号是否有误', "提示", {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '知道了',
                        showCancelButton:false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(action => {});
                }
            })
        },
        searchTel(){
            if(!this.moneyform.name){
                this.$confirm( '请先输入会员手机号/姓名再查询！', "提示", {
                    showCancelButton: false,
                    type: "warning"
                })
                return;
            }
            queryMemberOfflineForSearch({
                keyword:this.moneyform.name
            }).then(res=>{
                if(res.code == 0){
                    this.memInfo = '';
                    this.$confirm( '查不到该会员信息，请检查手机号/姓名输入是否有误', "提示", {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '知道了',
                        showCancelButton:false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(action => {});
                }else{
                    if(res.data.length > 0){
                        // 多条查询记录
                        this.memInfoList = res.data;
                        this.$emit('toMemListDialog',{dialog:true,data:this.memInfoList})
                    }else{
                        this.memInfo = res.data;
                    }
                }
            })
        },
        toPaswd(type,name,money){
            // 输入消费密码 1退货退款2退款
            this.$refs[name].validate(valid => {
                if(valid){
                    if(type == 2){
                        this.memInfo.returntotal = money;
                        this.memInfo.remarks = this.moneyform.leaveMsg;
                    }else{
                        // 判断是否已退货，提示“已退款过，请勿重复退款”,再判断剩余次数 提示“可退次数为0，不支持退货”
                        let isreturnList=[],isresidueFrequency = [],returnOrderDetails = this.form.servicePro.addType == 3 ? this.form.serviceProListNo : this.form.servicePro.orderGoodsDetailsList;
                        for(let m of returnOrderDetails){
                            isreturnList.push(m.isReturn);
                            if(m.courseStyle == 1){
                                isresidueFrequency.push(m.residueFrequency);
                            }
                        }
                        if(isreturnList.indexOf(1) != -1){
                            // 已退过货
                            this.$confirm( '已退款过，请勿重复退款', "提示", {
                                distinguishCancelAndClose: true,
                                confirmButtonText: '知道了',
                                showCancelButton:false,
                                type: "warning"
                            })
                            .then(() => {
                                return;
                            })
                            .catch(action => {});
                            return;
                        }else if(isresidueFrequency.indexOf(0) != -1){
                            // 剩余次数为0
                            this.$confirm( '可退次数为0，不支持退货', "提示", {
                                distinguishCancelAndClose: true,
                                confirmButtonText: '知道了',
                                showCancelButton:false,
                                type: "warning"
                            })
                            .then(() => {
                                return;
                            })
                            .catch(action => {});
                            return;
                        }

                        this.infoData.phone = this.infoData.memberTelephone;
                        this.infoData.returntotal = money;
                        this.infoData.chooseOrderGoodsList = this.computedOrderList(this.form.servicePro.id,returnOrderDetails)
                        this.infoData.returnStock = this.form.returnStock?this.form.returnStock:0;
                    }
                    this.$nextTick(()=>{
                        this.$emit('toPwdsDialog',{show:true,type:type,data:type == 1? this.infoData : this.memInfo});
                    })
                }else{
                    console.log("error submit!!");
                    return false;
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.returnGoodSale{
    border-radius: 2px;
    .searchBtn {
        width: 47px;
        height: 38px;
        border: none;
        background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .orangeFont{
        color: #F5BC4F
    }
    .el-form-item{
        margin-bottom: 0
    }
    .returnBtnOptions{
        text-align: center;
        margin-top: 26px;
        .el-button {
            min-width: 105px;
            height: 38px;
            border: none;
            font-size: 15px;
            &.is-disabled,&.is-disabled:focus,&.is-disabled:hover{
                background: #646b81;
                color: #fff;
            }
        }
    }
}
</style>
<style lang="less">
.returnGoodSale{
    .el-tabs__nav{
        width: 100%;
        background-color: #fff;
        color: #444;
    }
    .el-tabs--border-card>.el-tabs__header{
        .el-tabs__item{
            height: 55px;
            line-height: 55px;
            font-weight: bold;
            font-size: 15px;
            color: #444;
            margin:0;
            &:hover{
                color: #444;
            }
            &.is-active{
                background-color: #2ecfa7;
                color: #fff;
            }
        }
    }
    .el-tabs__content{
        padding: 30px 15px;
    }
    .redBtn {
        background: #F83B56;
        color: #fff;
    }
    .returnGoodDetail{
        .redLine{
            padding: 0 6px;
            height: 20px;
            line-height: 18px;
            font-size: 12px;
            color: #F83B56;
            font-weight: normal;
            border-radius: 0px 10px 10px 10px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            white-space: nowrap;
            border: 1px solid #f83b56;
            background: #fff;
            margin-left: 15px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/operatingFloor/returnGood.vue